/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `agent_memory` - AGENT_MEMORY
 * * `agent_schedule` - AGENT_SCHEDULE
 * * `attachment` - ATTACHMENT
 * * `automation` - AUTOMATION
 * * `chat` - CHAT
 * * `chat_message` - CHAT_MESSAGE
 * * `comment` - COMMENT
 * * `comment_reaction` - COMMENT_REACTION
 * * `connector` - CONNECTOR
 * * `connector_auth` - CONNECTOR_AUTH
 * * `dartboard` - DARTBOARD
 * * `dashboard` - DASHBOARD
 * * `doc` - DOC
 * * `event` - EVENT
 * * `event_subscription` - EVENT_SUBSCRIPTION
 * * `folder` - FOLDER
 * * `form` - FORM
 * * `form_field` - FORM_FIELD
 * * `layout` - LAYOUT
 * * `notification` - NOTIFICATION
 * * `option` - OPTION
 * * `property` - PROPERTY
 * * `relationship` - RELATIONSHIP
 * * `relationship_kind` - RELATIONSHIP_KIND
 * * `skill` - SKILL
 * * `space` - SPACE
 * * `status` - STATUS
 * * `task` - TASK
 * * `task_doc_relationship` - TASK_DOC_RELATIONSHIP
 * * `task_kind` - TASK_KIND
 * * `task_link` - TASK_LINK
 * * `tenant` - TENANT
 * * `text_snapshot` - TEXT_SNAPSHOT
 * * `user` - USER
 * * `user_dartboard_layout` - USER_DARTBOARD_LAYOUT
 * * `view` - VIEW
 * * `webhook` - WEBHOOK
 */
export enum OperationModelKind {
  AGENT_MEMORY = 'agent_memory',
  AGENT_SCHEDULE = 'agent_schedule',
  ATTACHMENT = 'attachment',
  AUTOMATION = 'automation',
  CHAT = 'chat',
  CHAT_MESSAGE = 'chat_message',
  COMMENT = 'comment',
  COMMENT_REACTION = 'comment_reaction',
  CONNECTOR = 'connector',
  CONNECTOR_AUTH = 'connector_auth',
  DARTBOARD = 'dartboard',
  DASHBOARD = 'dashboard',
  DOC = 'doc',
  EVENT = 'event',
  EVENT_SUBSCRIPTION = 'event_subscription',
  FOLDER = 'folder',
  FORM = 'form',
  FORM_FIELD = 'form_field',
  LAYOUT = 'layout',
  NOTIFICATION = 'notification',
  OPTION = 'option',
  PROPERTY = 'property',
  RELATIONSHIP = 'relationship',
  RELATIONSHIP_KIND = 'relationship_kind',
  SKILL = 'skill',
  SPACE = 'space',
  STATUS = 'status',
  TASK = 'task',
  TASK_DOC_RELATIONSHIP = 'task_doc_relationship',
  TASK_KIND = 'task_kind',
  TASK_LINK = 'task_link',
  TENANT = 'tenant',
  TEXT_SNAPSHOT = 'text_snapshot',
  USER = 'user',
  USER_DARTBOARD_LAYOUT = 'user_dartboard_layout',
  VIEW = 'view',
  WEBHOOK = 'webhook',
}
